module.exports = __webpack_public_path__ + "static/img/ic_fuqy.75e4982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_fuqy.png
// module id = iNRR
// module chunks = 19